import { getMechanicsQueryType } from 'features/getMechanics/types';

export const getMechanicsUrlConfig = ({ isActive, size }: getMechanicsQueryType) =>
  `/promo-b2b/admin/promo-b2b/admin/objectives/?page=1${size ? '&size=50' : ''}${
    isActive != null ? `&is_active=${isActive}` : ''
  }`;
